import { Component } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var TamediaPaywall = (function (_super) {
    __extends(TamediaPaywall, _super);
    function TamediaPaywall() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TamediaPaywall.prototype.componentDidMount = function () {
        if (this.props.isEnabled) {
            var isInApp = new URL(window.location.href).searchParams.has('appwebview');
            if (isInApp) {
                console.debug('[Paywall] Is in app, not executing paywall component.');
                return;
            }
            if (process.env.NODE_ENV === 'development' ||
                navigator.userAgent === 'ReactSnap') {
                console.debug('[Paywall] In Development mode, not executing paywall component.');
                return;
            }
            var script = window.document.createElement('script');
            script.async = true;
            script.src =
                'https://interaktiv.tagesanzeiger.ch/static/config/paywall.js';
            window.document.body.appendChild(script);
            var isPremium = this.props.paywallConfiguration.doc_type === 'premium';
            window._dsc = window._dsc || [];
            window._dsc.push(['abo', isPremium]);
        }
    };
    TamediaPaywall.prototype.render = function () {
        return null;
    };
    return TamediaPaywall;
}(Component));

export default TamediaPaywall;
export { TamediaPaywall as Paywall };
//# sourceMappingURL=index.js.map
